import {createRedux} from '../../../redux/factories/common/reduxFactory';

const {actionTypes, actions} = createRedux([
    'listUserOption',
    'listUserShareOption',
    'downloadUsers'
]);

const INIT_STATE = {
    corporateOptions: [],
    userOptions: [],
    userShareOptions: [],
    loading: false,
};

const userReducers = (state = INIT_STATE, action) => {
    if (Object.values(actionTypes).indexOf(action.type) === -1) {
        return {...state};
    }
    // list user options
    if (action.type === actionTypes['listUserOption']) {
        return {...state, loading: true};
    } else if (action.type === actionTypes['listUserOptionSuccess']) {
        const results = action.payload;
        return {...state, userOptions: results, loading: false};
    } else if (action.type === actionTypes['listUserOptionFailed']) {
        return {...state, loading: false};
    }

    // list user share options (for document sharing - requires Document permission only)
    if (action.type === actionTypes['listUserShareOption']) {
        return {...state, loading: true};
    } else if (action.type === actionTypes['listUserShareOptionSuccess']) {
        const results = action.payload;
        return {...state, userShareOptions: results, loading: false};
    } else if (action.type === actionTypes['listUserShareOptionFailed']) {
        return {...state, loading: false};
    }

    // download user list
    if (action.type === actionTypes['downloadUsers']) {
        return {...state, loading: true};
    } else if (action.type === actionTypes['downloadUsersSuccess']) {
        return {...state, loading: false};
    } else if (action.type === actionTypes['downloadUsersFailed']) {
        return {...state, loading: false};
    }
};

export {actions, actionTypes, userReducers};
